import React from 'react';
import { SEOHead } from '../seo';
import { seoConfigs } from '../../utils/seo-configs';

function ContactPage() {

  const contactMethods = [
    {
      title: "General Support",
      icon: "💬",
      description: "General questions about TherapyList",
      contact: "help@therapylist.com"
    },
    {
      title: "Emergency",
      icon: "🚨",
      description: "Mental health crisis support",
      contact: "Call 988 (Suicide & Crisis Lifeline)"
    }
  ];

  return (
    <>
      <SEOHead {...seoConfigs.contact} />
      
      <div className="min-h-screen bg-[#e4fde1]" style={{ marginTop: '-200px', paddingTop: '200px' }}>
        {/* Hero Section */}
        <div className="bg-[#e4fde1] py-16">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h1 className="text-4xl md:text-5xl font-bold mb-6 text-[#254e70]" style={{ fontFamily: 'Kanit Medium, sans-serif' }}>
              Contact TherapyList
            </h1>
            <p className="text-xl text-[#254e70]/80 mb-8 max-w-3xl mx-auto">
              We're here to help you find the right mental health professional or answer any questions about our platform.
            </p>
          </div>
        </div>

        {/* Contact Methods */}
        <div className="py-16">
          <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12">
              <h2 className="text-3xl md:text-4xl font-bold text-[#254e70] mb-4" style={{ fontFamily: 'Kanit Medium, sans-serif' }}>
                Get Support
              </h2>
              <p className="text-lg text-gray-600 max-w-2xl mx-auto">
                Choose the best way to reach us based on your needs. We're committed to providing timely and helpful support.
              </p>
            </div>

            <div className="grid md:grid-cols-2 gap-8 max-w-2xl mx-auto mb-16">
              {contactMethods.map((method, index) => (
                <div key={index} className="bg-white rounded-lg p-8 shadow-md hover:shadow-lg transition-shadow duration-200 text-center">
                  <div className="text-5xl mb-6">{method.icon}</div>
                  <h3 className="text-xl font-semibold text-[#254e70] mb-4" style={{ fontFamily: 'Kanit Medium, sans-serif' }}>
                    {method.title}
                  </h3>
                  <p className="text-gray-600 mb-4">
                    {method.description}
                  </p>
                  <p className="text-[#254e70] font-medium text-lg">
                    {method.contact}
                  </p>
                </div>
              ))}
            </div>
            
            <div className="text-center">
              <p className="text-lg text-[#254e70]/80 mb-4">
                Have a question or need assistance? We're here to help!
              </p>
              <p className="text-xl font-semibold text-[#254e70]">
                Email us at: <a href="mailto:help@therapylist.com" className="text-[#9dacff] hover:underline">help@therapylist.com</a>
              </p>
            </div>
          </div>
        </div>



        {/* FAQ Section */}
        <div className="py-16">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12">
              <h2 className="text-3xl md:text-4xl font-bold text-[#254e70] mb-4" style={{ fontFamily: 'Kanit Medium, sans-serif' }}>
                Frequently Asked Questions
              </h2>
            </div>

            <div className="space-y-6">
              <div className="bg-white rounded-lg p-6 shadow-md">
                <h3 className="text-lg font-semibold text-[#254e70] mb-2">
                  How quickly will I hear back from you?
                </h3>
                <p className="text-gray-600">
                  We typically respond to all inquiries within 24 hours during business days. For urgent matters, please call our support line during business hours.
                </p>
              </div>

              <div className="bg-white rounded-lg p-6 shadow-md">
                <h3 className="text-lg font-semibold text-[#254e70] mb-2">
                  I'm having a mental health emergency. What should I do?
                </h3>
                <p className="text-gray-600">
                  If you're experiencing a mental health emergency, please contact emergency services (911) or the 988 Suicide & Crisis Lifeline immediately. TherapyList is not equipped to handle crisis situations.
                </p>
              </div>

              <div className="bg-white rounded-lg p-6 shadow-md">
                <h3 className="text-lg font-semibold text-[#254e70] mb-2">
                  How can I update my therapist profile?
                </h3>
                <p className="text-gray-600">
                  Therapists can log into their dashboard to update their profile information, availability, and practice details. If you need assistance, contact our therapist support team.
                </p>
              </div>

              <div className="bg-white rounded-lg p-6 shadow-md">
                <h3 className="text-lg font-semibold text-[#254e70] mb-2">
                  Do you offer customer support in languages other than English?
                </h3>
                <p className="text-gray-600">
                  Currently, our primary customer support is in English. However, we're working to expand our multilingual support. Please reach out and we'll do our best to assist you or connect you with appropriate resources.
                </p>
              </div>
            </div>
          </div>
        </div>


      </div>
    </>
  );
}

export default ContactPage; 